var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "form-row" }, [
      _c("div", { staticClass: "form-group col-md-6" }, [
        _c("label", [_vm._v("บัญชีแสดงสัญญา")]),
        _c(
          "span",
          { staticClass: "required" },
          [_c("font", { attrs: { color: "red" } }, [_vm._v("*")])],
          1
        ),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.caNo,
              expression: "caNo"
            },
            {
              name: "validate",
              rawName: "v-validate",
              value: { required: true, max: 20 },
              expression: "{required:true,max:20}"
            }
          ],
          staticClass: "form-control",
          class: { input: true, "is-danger": _vm.errors.has("caNo") },
          attrs: {
            name: "caNo",
            disabled: this.reqType !== 1 && this.appVo.modifyFlag !== "Y",
            type: "number",
            placeholder: ""
          },
          domProps: { value: _vm.caNo },
          on: {
            keypress: function($event) {
              return _vm.isNumber($event)
            },
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.caNo = $event.target.value
            }
          }
        }),
        _c(
          "span",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.errors.has("caNo"),
                expression: "errors.has('caNo')"
              }
            ],
            staticClass: "help is-danger"
          },
          [_vm._v("กรอก บัญชีแสดงสัญญา")]
        )
      ]),
      _c("div", { staticClass: "form-group col-md-6" }, [
        _c("label", [_vm._v("เครื่องวัดหน่วยไฟฟ้า")]),
        _vm.caNo.substring(0, 2) !== "90"
          ? _c(
              "span",
              { staticClass: "required" },
              [_c("font", { attrs: { color: "red" } }, [_vm._v("*")])],
              1
            )
          : _vm._e(),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.meterNo,
              expression: "meterNo"
            },
            {
              name: "validate",
              rawName: "v-validate",
              value: { required: true, max: 20 },
              expression: "{required:true,max:20}"
            }
          ],
          staticClass: "form-control",
          class: { input: true, "is-danger": _vm.errors.has("meterNo") },
          attrs: {
            name: "meterNo",
            disabled:
              _vm.caNo.substring(0, 2) == "90" ||
              (this.reqType !== 1 && this.appVo.modifyFlag !== "Y"),
            type: "number",
            placeholder: ""
          },
          domProps: { value: _vm.meterNo },
          on: {
            keypress: function($event) {
              return _vm.isNumber($event)
            },
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.meterNo = $event.target.value
            }
          }
        }),
        _c(
          "span",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.errors.has("meterNo"),
                expression: "errors.has('meterNo')"
              }
            ],
            staticClass: "help is-danger"
          },
          [_vm._v("กรอก เครื่องวัดหน่วยไฟฟ้า")]
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }